module.exports = __webpack_public_path__ + "static/illustration-1.1-b67a7ca3937b9731a9ca5abddf5f2bc0.svg";